export default __webpack_public_path__ + "static/media/Group_7442.0ca16841.png";